import type { CopilotSettingsResponse } from '../types/serviceTypes';
import type { CopilotOnboardingStatus } from '../types/serviceSettingTypes';
import { Scenario } from '../types/serviceSettingTypes';

/**
 * Reads the PersonalOS onboarding status passed through on the copilotsettings
 * response. The field is scenario-specific, so it is pulled out here rather than
 * threaded through the shared per-scenario `FeatureInfo` mapping.
 */
export function getOnboardingStatusFromResponse(
    response: CopilotSettingsResponse | undefined
): CopilotOnboardingStatus | undefined {
    return response?.supportedScenarios?.find(scenario => scenario.scenario === Scenario.PersonalOS)
        ?.onboardingStatus;
}
